import React from 'react';
import { MainContent } from '../../utilities/mainContent';
import TableData from '../../utilities/table';
import {
  Grid,
  IconButton,
  MenuItem,
  ListItemText,
  ListItemIcon,
  Typography,
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import EditIcon from '@mui/icons-material/Edit';
import { MenuButtons } from '../../utilities/menuButton';
import DeleteIcon from '@mui/icons-material/Delete';
import { DialogBox } from '../../utilities/dialog';
import { DeleteContent } from '../../../hooks/utils';
import { Add } from './add';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import AssetService from '../../../service/asset';
import { usePerms } from '../../../hooks/usePerms';

const items = [
  {
    label: 'Edit manufacture',
    icon: <EditIcon fontSize='small' />,
  },
  {
    label: 'Delete manufacture',
    icon: <DeleteIcon fontSize='small' />,
  },
];
const itemsAdmin = [
  {
    label: 'Edit manufacture',
    icon: <EditIcon fontSize='small' />,
  },
];

const csvCol = [
  {
    key: 'name',
    label: 'Name',
  },

  {
    key: 'createdAt',
    label: 'CreatedAt',
  },
  {
    key: 'updatedAt',
    label: 'UpdatedAt',
  },
];

export const AssetManufactureComponent = () => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [isDialog, setIsDialog] = React.useState(false);
  const [setMobileOpens, setMobileOpenss] = React.useState(false);
  const [manufacture, setManufacture] = React.useState(null);
  const [filtered, setFiltered] = React.useState(null);
  const [isDelete, setIsDelete] = React.useState(false);
  const queryClient = useQueryClient();
  const entryRole = ['admin'];
  const entryRole2 = ['user'];
  const { role: role2 } = usePerms('', entryRole2);
  const { role } = usePerms('', entryRole);

  const itemsCheck = role ? itemsAdmin : items;
  const { data, isLoading } = useQuery({
    queryKey: ['assetManufacture'],
    queryFn: () => AssetService.allAssetLabel('manufacture'),
  });

  const { mutate } = useMutation({
    mutationFn: AssetService.AssetLabel,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['assetManufacture'] });
      setIsDelete(false);
    },
  });
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const toggleDrawer = () => {
    setMobileOpenss(!setMobileOpens);
  };

  const columns = [
    {
      field: 'name',
      headerName: 'Name',
      width: 580,
    },

    {
      field: 'createdAt',
      headerName: 'CreatedAt',
      width: 250,
    },
    {
      field: 'updatedAt',
      headerName: 'UpdatedAt',
      width: 240,
    },

    {
      field: '',
      headerName: '',
      width: 80,
      renderCell: (params) => {
        return (
          <Grid container justifyContent='flex-end'>
            <IconButton
              aria-controls={open ? 'fade-menu' : undefined}
              aria-haspopup='true'
              aria-expanded={open ? 'true' : undefined}
              onClick={handleClick}
              disabled={role2 ? true : false}
            >
              <MoreVertIcon />
            </IconButton>
            <MenuButtons
              anchorEl={anchorEl}
              open={open}
              handleClose={handleClose}
              items={itemsCheck.map((item, index) => (
                <MenuItem
                  key={index}
                  onClick={() => handleMenuItem(item, params)}
                >
                  <ListItemIcon>{item.icon}</ListItemIcon>
                  <ListItemText>
                    <Typography variant='subtitle2'>{item.label}</Typography>
                  </ListItemText>
                </MenuItem>
              ))}
            />
          </Grid>
        );
      },
    },
  ];

  const handleMenuItem = (item, params) => {
    if (item.label === 'manufacture') {
      toggleDrawer();
      setAnchorEl(null);
    } else if (item.label === 'Edit manufacture') {
      // navigate('/inspection/edit');
      setAnchorEl(null);
      setIsDialog(() => true);
    } else if (item.label === 'Delete manufacture') {
      setAnchorEl(null);
      setIsDelete(() => true);
    } else {
      return null;
    }
  };
  return (
    <>
      <MainContent
        csvData={data}
        valueFrom='add_assetmanufacture'
        csvHeaders={csvCol}
        csvDataWithFilter={filtered || data}
        csvHeadersWithFilter={csvCol}
        fileNameWithFilter={'Assert Manufacture list'}
        fileName={'Assert Manufacture list'}
        onChangeSearch={(val) => {
          const searchVal = val?.target?.value || '';
          if (!searchVal) {
            setFiltered(() => data);
            return;
          }
          const value = (data || []).filter(
            (item) => item?.name?.toLowerCase().indexOf(searchVal.toLowerCase()) > -1
          );
          setFiltered(() => value);
        }}
        title='Manufacture Assets'
        isBtnName={true}
        btnName={'Add'}
        onBtnNameClick={() => {
          setManufacture(null);
          setIsDialog(true);
        }}
        items={
          <TableData
            cols={columns}
            rows={filtered ? filtered : data}
            height='400px'
            isLoading={isLoading}
            onRowClick={({ row }) => setManufacture(() => row)}
          />
        }
      />
      <DialogBox
        handleClose={() => setIsDialog(false)}
        open={isDialog}
        title={
          <Typography variant='subtitle1' component='span'>
            Add Asset Manufacture
          </Typography>
        }
        content={
          <Add
            label_name='Manufacture'
            handleClose={() => setIsDialog(false)}
            manufacture={manufacture}
            mutationFn={
              manufacture ? AssetService.AssetLabel : AssetService.addAssetLabel
            }
          />
        }
      />
      <DialogBox
        handleClose={() => setIsDelete(false)}
        open={isDelete}
        maxWidth='500px'
        title={
          <Typography variant='subtitle1' component='span'>
            Delete Asset Manufacture
          </Typography>
        }
        content={
          <DeleteContent
            title='Are you sure you want to delete this asset Manufacture ?'
            onCancel={() => setIsDelete(false)}
            onSubmit={() => {
              const id = manufacture.id;
              const method = 'delete';
              const label = 'manufacture';
              mutate({ id, method, label });
            }}
          />
        }
      />
    </>
  );
};
